import React from 'react';
import styled from '@emotion/styled';

type IndicatorProps = {
  isActive: boolean;
  size?: 'small';
};

const Indicator = styled('div')(({ isActive, size }: IndicatorProps) => ({
  minWidth: '4px',
  minHeight: '100%',
  background: 'white',
  borderRadius: '4px',
  margin: size === 'small' ? '2px 0 2px 2px' : '6px 0 6px 2px',
  visibility: isActive ? 'visible' : 'hidden',
}));

export const ActiveMenuLinkIndicator = React.memo(
  ({ isActive, size }: IndicatorProps) => (
    <Indicator isActive={isActive} size={size} aria-hidden={!isActive} />
  )
);
